import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  Categoria,
  CategoriaRecordatorio,
  ICreateDocumentacion,
  ICreateRecordatorio,
  IDocumentacion,
  IFilter,
  IRecordatorio,
  IUpdateDocumentacion,
  IUpdateRecordatorio,
  TipoDocumentacion,
} from 'modelos/src';
import { MatDialogRef } from '@angular/material/dialog';
import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';

import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { DocumentosService } from '../../../../auxiliares/servicios/http/documentos.service';
import { ParamsService } from '../../../../auxiliares/servicios/params.service';
import { UploadFileComponent } from '../../../../auxiliares/upload-file/upload-file.component';
import { RecordatoriosService } from '../../../../auxiliares/servicios/http/recordatorios.service';

@Component({
  imports: [AuxiliaresModule, UploadFileComponent],
  selector: 'app-crear-editar-documento',
  templateUrl: './crear-editar-documento.component.html',
  styleUrl: './crear-editar-documento.component.scss',
})
export class CrearEditarDocumentoComponent implements OnInit {
  private documentosService = inject(DocumentosService);
  helper = inject(HelperService);
  private recordatorioService = inject(RecordatoriosService);
  private dialogService = inject(DialogService);
  private paramsService = inject(ParamsService);
  dialog = inject<MatDialogRef<CrearEditarDocumentoComponent>>(MatDialogRef);

  public form?: FormGroup;
  public title?: string;
  public tipos: TipoDocumentacion[] = ['Seguro', 'Licencia'];
  public id?: string | null;
  public tipo?: string | null;
  public categoria?: CategoriaRecordatorio;
  public documento?: IDocumentacion;
  public loading: boolean = false;
  public recordatorioAsociado?: IRecordatorio;

  private createForm() {
    this.form = new FormGroup({
      idChofer: new FormControl(this.documento?.idChofer),
      tipo: new FormControl(this.documento?.tipo, Validators.required),
      idActivo: new FormControl(this.documento?.idActivo),
      idCliente: new FormControl(this.documento?.idCliente),
      descripcion: new FormControl(this.documento?.descripcion),
      emision: new FormControl(this.documento?.emision),
      vencimiento: new FormControl(this.documento?.vencimiento),
      imagenes: new FormControl(this.documento?.imagenes),
    });
  }

  get documentoImagenes() {
    return this.form?.get('imagenes') as FormGroup;
  }

  //
  public async onSubmit() {
    const res = await this.dialogService.confirm(
      `Confirmá la acción`,
      `¿Querés ${this.id ? 'editar' : 'crear'} el documento?`,
    );
    if (!res) return;
    this.loading = true;
    try {
      const data = this.getData();
      if (this.id) {
        // Update
        const res = await this.documentosService.update(this.id, data);
        this.helper.notifSuccess('Documento actualizado');

        //Traemos el recordatorio asociado y lo actualizamos
        const recordFilter: IFilter<IRecordatorio> = {
          idDocumentacion: this.id,
        };
        const query = {
          filter: JSON.stringify(recordFilter),
          limit: 1,
          select: '_id',
        };
        const recordatorioAsociado =
          await this.recordatorioService.getFiltered(query);
        const updateRecordatorio: IUpdateRecordatorio = {
          fechaLimite: res.vencimiento,
        };
        await this.recordatorioService.update(
          recordatorioAsociado.datos[0]._id,
          updateRecordatorio,
        );

        this.dialog.close(res);
      } else {
        // Create
        const doc = await this.documentosService.create(data);

        const recordatorio: ICreateRecordatorio = {
          tipo: ['fecha'],
          fechaLimite: doc.vencimiento,
          notificado: false,
          idUsuario: doc.idChofer,
          idActivo: doc.idActivo,
          idDocumentacion: doc._id,
          categoria: this.categoria,
        };
        await this.recordatorioService.create(recordatorio);
        this.helper.notifSuccess('Documento creado');
        this.dialog.close(doc);
      }
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public getData(): ICreateDocumentacion | IUpdateDocumentacion {
    const data: ICreateDocumentacion | IUpdateDocumentacion = this.form?.value;
    return data;
  }

  public loadingFile(bool: boolean) {
    this.loading = bool;
  }
  public onUrlChange(url: string) {
    const imagenes = this.form?.value.imagenes;
    if (imagenes) {
      imagenes.push(url);
      this.form?.patchValue({ imagenes: imagenes });
    } else this.form?.patchValue({ imagenes: [url] });
  }

  public eliminarImagen(index: number) {
    const imagenes = this.form?.value.imagenes;
    imagenes.splice(index, 1);
    this.form?.patchValue({ imagenes: imagenes });
  }

  async ngOnInit() {
    const params = this.paramsService.getParams();
    this.documento = params['documento'];
    this.id = this.documento?._id;
    this.tipo = params['tipoEntidad'];
    this.categoria = params['categoria'] as CategoriaRecordatorio;
    this.createForm();
    if (!this.id) {
      //CREAR
      this.form.patchValue({
        idCliente: params['idCliente'],
      });
      this.title = 'Crear Documento';
      if (this.tipo === 'Usuario' && this.form)
        this.form.patchValue({
          idChofer: params['idEntidad'],
        });
      if (this.tipo === 'Vehiculo' && this.form) {
        this.tipos = ['Seguro'];
        this.form.patchValue({
          idActivo: params['idEntidad'],
        });
      }
      if (this.tipo === 'Colectivo' && this.form) {
        this.tipos = ['Seguro'];
        this.form.patchValue({
          idActivo: params['idEntidad'],
        });
      }
    } else {
      //EDITAR
      this.title = 'Editar Documento';
    }
  }
}
